<template>
    <div class="row">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'row',
    components: {},
    props: {}
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.row
    display: flex
    width: 100%
    flex-grow: 0
    margin-bottom: 20px

    @media screen and (max-width: 480px)
        display: block
</style>
